import React, { useState, useEffect } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import styles from './DashboardLayout.module.scss';

interface DashboardLayoutProps {
    children: React.ReactNode;
    className?: string;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({ 
    children, 
    className 
}) => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Check if we're in mobile view
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 960);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Close sidebar when switching from mobile to desktop
    useEffect(() => {
        if (!isMobile) {
            setIsSidebarOpen(false);
        }
    }, [isMobile]);

    const handleMenuToggle = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };

    const handleSidebarClose = () => {
        setIsSidebarOpen(false);
    };

    return (
        <div className={`${styles.dashboardLayout} ${className || ''}`}>
            {/* Header */}
            <Header 
                onMenuToggle={handleMenuToggle}
                isMobile={isMobile}
                className={styles.header}
            />

            {/* Main content area */}
            <div className={styles.mainContent}>
                {/* Sidebar */}
                <Sidebar 
                    isOpen={isSidebarOpen}
                    onClose={handleSidebarClose}
                    isMobile={isMobile}
                />

                {/* Content area */}
                <main className={styles.contentArea}>
                    <div className={styles.contentWrapper}>
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default DashboardLayout;
